import PropTypes from 'prop-types';
import React from 'react';
import { formatNumber } from '../../../shared/formattingUtils';

const TabStrip = ({ tabs, activeTab, setActiveTab, tabCounts }) => (
  <div className="tickets-tab-strip">
    {tabs.map((tab) => {
      const isActive = activeTab === tab.key;
      const count = tabCounts[tab.key];
      return (
        <button
          key={tab.key}
          type="button"
          onClick={() => setActiveTab(tab.key)}
          className={`btn btn-sm d-inline-flex align-items-center tickets-tab-pill ${isActive ? 'active' : ''}`.trim()}
        >
          {tab.label}
          {count != null && count > 0 && (
            <span className="tickets-tab-count">{formatNumber(count)}</span>
          )}
        </button>
      );
    })}
  </div>
);

TabStrip.propTypes = {
  tabs: PropTypes.arrayOf(PropTypes.shape({
    key: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
  })).isRequired,
  activeTab: PropTypes.string.isRequired,
  setActiveTab: PropTypes.func.isRequired,
  tabCounts: PropTypes.object.isRequired,
};

export default TabStrip;
